export default __webpack_public_path__ + "static/activerse_logo-ff08cc5fd6887959d1a3348a59e8d8c1.svg";